import { z } from 'zod';
import { id } from './common';

export const colorEntitySchema = z.object({
  id,
  value: z.string().max(7)
});

export const colorsSchema = z.array(colorEntitySchema);